import Swal from "sweetalert2";
import {
  ADDCOURSE,
  ADDINSTITUTE,
  GETCOURSES,
  GETCOURSESENQUIRIES,
  GETINSTITUTE,
  UPDATECOURSE,
  UPDATEINSTITUTE,
} from "../../utils/api";
import axios from "../../utils/axios";
import { swalAlertPopProps } from "../../utils/commonUtils";

export const getAllCourses = async (payload, callback) => {
  await axios
    .post(GETCOURSES, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const getAllEnquiriesById = async (payload, callback) => {
  await axios
    .post(GETCOURSESENQUIRIES, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const courseAdd = async (payload, callback) => {
  await axios
    .post(ADDCOURSE, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully Added",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
export const courseUpdate = async (payload, callback) => {
  await axios
    .post(UPDATECOURSE, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getInstitute = async (payload, callback) => {
  await axios
    .post(GETINSTITUTE, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const institueUpdate = async (payload, callback) => {
  await axios
    .post(UPDATEINSTITUTE, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const institueAdd = async (payload, callback) => {
  await axios
    .post(ADDINSTITUTE, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully Added",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};